let shared={
    filterStatus:[
       { id:'',name:'All'},
       { id:'active',name:'Active'},
       { id:'deactive',name:'Deactive'}
    ]
}
export default shared